type QueryParamValue = string | string[] | null | undefined;

export type EmbeddedWhiteboardModeParams = {
	parentProduct?: QueryParamValue;
	presentationMode?: QueryParamValue;
};

const isQueryParamPresent = (value: QueryParamValue): boolean =>
	Array.isArray(value) ? value.length > 0 : Boolean(value);

/**
 * Determines whether Whiteboards should use the "embedded" experience (e.g. /canvas-embed base).
 *
 * This is currently controlled by the `parentProduct` and `presentationMode` query parameters.
 */
export const isEmbeddedWhiteboardMode = ({
	parentProduct,
	presentationMode,
}: EmbeddedWhiteboardModeParams): boolean =>
	isQueryParamPresent(parentProduct) || isQueryParamPresent(presentationMode);
